export default __webpack_public_path__ + "static/media/mTop_1.1d35c853.bin";